<template>
  <input :class="[inputClass, {['error-label']: errorMessage || customError}]"
         :id="inputId"
         :name="inputId"
         :placeholder="placeholder"
         :step="step"
         :min="min"
         :max="max"
         type="number"
         v-model="inputValue"
         @blur="onBlurInput"
         @change="onChangeInput"
         @keypress="onKeyPress" />
</template>


<script>
  export default {
    props: {
      customError: String,
      isOptOutInput: Boolean,
      inputClass: String,
      inputId: [Number, String],
      isCurrency: Boolean,
      numberValue: [Number, String],
      placeholder: String,
      step: [Number, String],
      useCustomValidation: Boolean,
      zeroAllowed: Boolean,
      min: Number,
      max: Number
    },

    name: 'NumberInput',

    data() {
      return {
        delay: null,
        errorMessage: null,
        inputValue: null,
      }
    },

    methods: {
      onBlurInput(event) {
        const $target = event.currentTarget
        this.isOptOutInput ? this.selectValidation(event.currentTarget) : this.$emit('setInteractions', this.inputId)
        if (!$target.value) { this.selectValidation($target) }
      },

      onChangeInput(event) {
        !this.isOptOutInput && this.selectValidation(event.currentTarget)
      },

      onKeyPress(event) {
        const keyCode = event.which,
              isValidKeyCode = (keyCode < 48 || keyCode > 57) && keyCode !== 13,
              isEnterKey = keyCode === 13
        if (this.isOptOutInput) {
          isValidKeyCode && event.preventDefault()
          isEnterKey && this.selectValidation(event.currentTarget)
        }
      },

      selectValidation($target) {
        if (this.useCustomValidation) {
          this.$emit('customValidation', $target)
        } else {
          this.validateNumberInput($target)
        }
      },

      validateNumberInput($target) {
        let value = $target.value.trim()
        const parsedValue = parseInt(value)
        value = this.isCurrency ? value.replace(/[^\d.-]/g, '') : value.replace(/\D/g, '')
        const isWithinMax = this.max >= value
        const isWithinMin = this.min <= value
        let isWithinRange = false
        if (this.max && this.min) {
          isWithinRange = isWithinMax && isWithinMin
        } else if (this.max) {
          isWithinRange = isWithinMax
        } else if (this.min) {
          isWithinRange = isWithinMin
        } else {
          isWithinRange = true
        }

        const isZeroAllowedValid = this.zeroAllowed ? parsedValue >= 0 : parsedValue > 0
        const isValid = isWithinRange && isZeroAllowedValid

        if (isValid && !!value) {
          if (parsedValue !== parseInt(this.numberValue)) { this.$emit('saveInput', value) }
          this.errorMessage = null
        } else if (!isZeroAllowedValid) {
          const errorMessage = this.zeroAllowed ? 'must be a zero or above' : 'must be greater than zero'
          this.errorMessage = errorMessage
        } else if (!isWithinRange) {
          const errorMessage = isWithinMax ? `Number cannot be less than ${this.min}` : `Number cannot be greater than ${this.max}`
          this.errorMessage = errorMessage
        }
      }
    },

    created() {
      if (this.numberValue) {
        this.inputValue = this.numberValue
      }
    },

    watch: {
      errorMessage: function() {
        this.$emit('setErrorText', this.errorMessage)
      },

      numberValue: function() {
        this.inputValue = this.numberValue
      }
    }
  }
</script>
